"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGeoObjectTypeInstance = exports.s2CellIdToGeoPointType = exports.getCellIdId = exports.getLevelParent = exports.convertLatLngLocationToId = exports.convertPointLatLngMap = exports.convertPointLatLngArr = void 0;
const tslib_1 = require("tslib");
const nodes2ts_1 = require("nodes2ts");
const uuid_1 = require("uuid");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const bbox_1 = require("@turf/bbox");
const lambda_1 = require("../../lambda");
const debug = lambda_1.DEBUG_OVERRIDE || (!lambda_1.IS_LAMBDA && false);
const convertPointLatLngArr = ([lat, lng]) => (0, exports.convertPointLatLngMap)({ lat, lng });
exports.convertPointLatLngArr = convertPointLatLngArr;
const convertPointLatLngMap = (latLngMap) => {
    const { lat, lng } = latLngMap;
    const s2LatLng = nodes2ts_1.S2LatLng.fromDegrees(lat, lng);
    const s2Point = s2LatLng.toPoint();
    const s2cellId = nodes2ts_1.S2CellId.fromPoint(s2Point);
    return s2cellId;
};
exports.convertPointLatLngMap = convertPointLatLngMap;
/** convert Position or Polygon into a level 22 s2CellTokem
 * the defaultLevel is 20 which is approx 10m squarish in medium latitudes
 * the used level for locating a point is therefore 22, which is approx 2m squarish
 */
const convertLatLngLocationToId = (latLngMap, level = config_1.default.app.geo.S2.defaultLevel + 2) => {
    return (0, exports.convertPointLatLngMap)(latLngMap).parentL(level).toToken();
};
exports.convertLatLngLocationToId = convertLatLngLocationToId;
const getLevelParent = (s2CellId, level = config_1.default.app.geo.S2.defaultLevel) => s2CellId.parentL(level);
exports.getLevelParent = getLevelParent;
const getCellIdId = (s2CellId) => s2CellId.id;
exports.getCellIdId = getCellIdId;
const s2CellIdToGeoPointType = (s2CellId) => {
    const parentCellId = (0, exports.getLevelParent)(s2CellId);
    const s2CellToken = parentCellId.toToken();
    const parentCell = new nodes2ts_1.S2Cell(parentCellId);
    const feature = parentCell.toGEOJSON();
    feature.id = s2CellToken;
    const geoObjectInstance = (0, exports.createGeoObjectTypeInstance)(feature, s2CellToken);
    if (!geoObjectInstance) {
        debug && console.log(`No geopointInstance create with`, { s2CellId });
    }
    else {
        debug && console.log(`created geopointInstance create with`, { s2CellId, geoObjectInstance });
    }
    return geoObjectInstance;
};
exports.s2CellIdToGeoPointType = s2CellIdToGeoPointType;
const createGeoObjectTypeInstance = (feature, s2CellToken) => {
    let zombieObject = undefined;
    debug && console.log('createInstance', feature);
    const type = s2CellToken ? 'Point' : feature.geometry.type;
    switch (type) {
        case 'Point':
            {
                const point = feature;
                const [lat, lng, z] = point.geometry.coordinates;
                const s2CellId = (0, exports.convertPointLatLngArr)([lat, lng]);
                const s2CellTokenFromLatLng = s2CellId.toToken();
                const id = s2CellToken ?? s2CellTokenFromLatLng;
                const sk = `${type}:${id}`, pk = sk;
                zombieObject = {
                    type,
                    id,
                    sk,
                    pk,
                    position: s2CellToken ? undefined : { lat, lng },
                    bbox: point.bbox ?? (0, bbox_1.bbox)(point),
                    geoJson: point,
                    name: point?.properties?.name,
                    description: point?.properties?.description,
                };
            }
            break;
        case 'LineString':
            {
                const lineString = feature;
                debug && console.log('feature at Linestring', lineString);
                const idHash = lineString.geometry.coordinates.map(([lat, lng]) => `${lat},${lng}`).join('');
                const id = s2CellToken ?? (0, uuid_1.v5)(idHash, config_1.default.app.namespace_uuid), sk = `${type}:${id}`, pk = sk;
                zombieObject = {
                    type,
                    id,
                    sk,
                    pk,
                    bbox: lineString.bbox ?? (0, bbox_1.bbox)(lineString),
                    geoJson: lineString,
                    name: lineString?.properties?.name,
                    description: lineString?.properties?.description,
                };
            }
            break;
        case 'Polygon':
            {
                const polygon = feature;
                const idHash = polygon.geometry.coordinates.map(([lat, lng]) => `${lat},${lng}`).join('');
                const id = s2CellToken ?? (0, uuid_1.v5)(idHash, config_1.default.app.namespace_uuid);
                const sk = `${type}:${id}`;
                zombieObject = {
                    type,
                    id,
                    sk,
                    pk: sk,
                    bbox: polygon.bbox ?? (0, bbox_1.bbox)(polygon),
                    geoJson: polygon,
                    name: polygon?.properties?.name,
                    description: polygon?.properties?.description,
                };
            }
            break;
    }
    exports.s2CellIdToGeoPointType;
    return zombieObject;
};
exports.createGeoObjectTypeInstance = createGeoObjectTypeInstance;
